import {
    List,
    Datagrid,
    FunctionField,
    GetListResult
} from 'react-admin';
import { useLocation } from 'react-router-dom';
import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { Courier } from '../../types/courier';
import { EmptyBox } from '../empty-box/EmptyBox.tsx';

//TODO: move styles to a separate file if possible

const CommissionCouriersTableActions = () => {
    const location = useLocation();
    const agencyName = (location.state as { agencyName?: string } | null)?.agencyName;

    const { t } = useTranslation();

    return (
        <Box
            sx={{
                paddingTop: 'var(--space-72)',
                paddingBottom: 'var(--space-32)',
                flex: 1,
                display: 'flex',
                alignItems: 'start',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <Typography variant="h5" sx={{
                paddingLeft: 'var(--space-24)',
                fontWeight: 700,
                fontSize: 'var(--text-xxl)',
            }}>
                {t('resources.commissionManagement')}
            </Typography>
            <Divider
                variant="middle"
                sx={{
                    width: '460px',
                    alignSelf: 'stretch',
                    my: 'var(--space-24)',
                    borderTopWidth: 1,
                    borderColor: 'var(--color-secondary)',
                }}
            />

            <Typography variant="h5" sx={{
                paddingLeft: 'var(--space-24)',
                fontWeight: 700,
                fontSize: 'var(--text-lg)',
            }}>
                {agencyName}
            </Typography>
        </Box>
    );
};

export const CommissionCouriersTable = () => {
    const { t } = useTranslation();

    const location = useLocation();
    const agencyName = (location.state as { agencyName?: string } | null)?.agencyName;

    return (
        <List
            title={t("resources.commissionManagement")}
            filter={agencyName ? { agencyName } : undefined}
            actions={<CommissionCouriersTableActions />}
            perPage={25}
            empty={<EmptyBox title="No Couriers yet." description='Do you want to add one?' resource="riderManagement"/>}
            queryOptions={{
                select: (res: GetListResult<Courier>): GetListResult<Courier> => {
                    const data = Array.isArray(res?.data) ? res.data : [];
                    const filtered = agencyName ? data.filter(r => r.agencyName === agencyName) : data;
                    return {
                        ...res,
                        data: filtered,
                        total: filtered.length,
                    };
                },
            }}
            resource="commissionCouriers"
            sx={{
                    '& .RaList-main': { px: 4 },
                    '& .RaList-content': {
                        border: '1px solid var(--color-secondary)',
                        borderRadius: 'var(--radius-6)',
                    },
                    '& .RaDatagrid-tbody tr:last-of-type td': {
                        borderBottom: 'none',
                    },
                    '& th.MuiTableCell-root': {
                        paddingLeft: 'var(--space-24)',
                        py: 'var(--space-16)',
                        fontSize: 'var(--text-xs)',
                    },
                    '& td.MuiTableCell-root': {
                        py: 'var(--space-24)',
                        paddingLeft: 'var(--space-24)',
                        fontSize: 'var(--text-xs)',
                    },
                    '& .MuiTablePagination-root': {
                        '& .MuiSelect-select': {
                            paddingRight: '32px !important',
                            paddingLeft: '12px !important',
                        },
                        '& .MuiSelect-icon': {
                            right: '8px',
                        }
                    }
                }}
            >
            <Datagrid
                bulkActionButtons={false}
                rowClick={false}
                sx={{
                    '& .RaDatagrid-headerCell': {
                        fontWeight: 700,
                        letterSpacing: 0.2,
                    },
                }}
            >
                <FunctionField
                sortable={false}
                    label={t('members.columns.id')}
                    render={(record: any) => (record?.id ?? '')}
                />
                <FunctionField
                sortable={false}
                    label={t('members.columns.typeOfVehicle')}
                    render={(record: any) => (record?.vehicleType ?? '')}
                />
                <FunctionField
                sortable={false}
                    label={t('members.columns.name')}
                    render={(record: any) => (record?.firstName)}
                />
                <FunctionField
                sortable={false}
                    label={t('members.columns.surname')}
                    render={(record: any) => (record?.lastName)}
                />
                <FunctionField
                sortable={false}
                    label={t('members.columns.phone')}
                    render={(record: any) => (record?.phoneNumber ?? '')}
                />
            </Datagrid>
        </List>
    )
};